import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyFees } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./WithdrawalFeesPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const WithdrawalFeesPage = () => {
  const [fees] = useState(dummyFees);
  const [search, setSearch] = useState("");

  const filtered = fees.filter(
    (f) =>
      f.uuid?.toLowerCase().includes(search.toLowerCase()) ||
      f.emailId?.toLowerCase().includes(search.toLowerCase()) ||
      f.short_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Withdrawal Fees</span>
          </p>
          <h1 className="dashboard-hero__title">Withdrawal Fees</h1>
          <p className="dashboard-hero__subtitle">
            Set withdrawal fees by coin and network
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-percent" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="withdrawalfees-section">
          <div className="withdrawalfees-section__header">
            <div className="withdrawalfees-section__title-wrap">
              <span className="withdrawalfees-section__icon">
                <i className="fas fa-coins" />
              </span>
              <h2 className="withdrawalfees-section__title">Withdrawal Fee Records</h2>
            </div>
            <div className="withdrawalfees-section__stats">
              <span className="withdrawalfees-stat">
                <strong>{fees.length}</strong> Records
              </span>
            </div>
          </div>
          <div className="withdrawalfees-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by UUID, email or currency..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="withdrawalfees-search-input"
            />
          </div>
          <div className="withdrawalfees-table-wrap">
            <table className="withdrawalfees-table">
              <thead>
                <tr>
                  <th>Created</th>
                  <th>Updated</th>
                  <th>UUID</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>Fee</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row, i) => (
                  <tr key={row.uuid || i}>
                    <td>{formatDate(row.createdAt)}</td>
                    <td>{formatDate(row.updatedAt)}</td>
                    <td><span className="withdrawalfees-mono">{row.uuid}</span></td>
                    <td>{row.emailId}</td>
                    <td>{row.mobileNumber}</td>
                    <td><strong>{row.short_name}</strong></td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td>{typeof row.fee === "number" ? row.fee.toLocaleString("en-IN", { minimumFractionDigits: 4 }) : row.fee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="withdrawalfees-empty">No withdrawal fee records match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default WithdrawalFeesPage;
